import React, { useEffect, useState } from "react";
import TextField from '@mui/material/TextField';
import { styled } from "@mui/material/styles";
import { Typography, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import { GetInsuresStatusByHealthFacility, fetchInsureeByName, fetchInsureeByUuid, fetchSubstitute, GetSubstituteStatusByHealthFacility } from "../action";

const InsureeMedicalStatus = ({ value, label, onChange, id, type, error, placeholder, insureeNo, input, meta, values, substitutionDoctor,  hf_Uuid, name, ...props }) => {
    const SignInSuccess = useSelector((state) => state);
    
    const [insureeData, setInsureeData] = useState();
    const [chfId, setChfId] = useState("");
    const [otherNames, setOtherNames] = useState("");
    const dispatch = useDispatch();
    useEffect(() => {
        if (values && hf_Uuid) {
            dispatch(GetInsuresStatusByHealthFacility(hf_Uuid, values))
            dispatch(fetchInsureeByUuid(values))
        }
        if (!values && hf_Uuid && substitutionDoctor) {
            dispatch(GetSubstituteStatusByHealthFacility(hf_Uuid, substitutionDoctor))
            dispatch(fetchSubstitute(substitutionDoctor))
        }
    }, [values, hf_Uuid, substitutionDoctor])
    const Content = styled(Typography)`
  margin-bottom: 0.3rem;
`;
    return (
        <>
            <Content>
                <Typography color="#666666">
                    {label}
                </Typography>
            </Content>
            <Box
                component="form"
                sx={{
                    "& .MuiTextField-root": { width: "100%" },
                }}
                noValidate
                autoComplete="off"
            >
                <Grid style={{ display: "flex" }}>
                    <TextField
                        style={{ marginLeft: "10px" }}
                        variant="outlined"
                        value={
                            values ? SignInSuccess?.fosaReducer?.HfInsureeStatus?.status : SignInSuccess?.fosaReducer?.HfSubstituteStatus?.status
                        }
                        disabled={true}
                        fullWidth
                        size="small"
                    />
                </Grid>
            </Box>
        </>
    );
};

export default InsureeMedicalStatus;
